import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/SocialResponsibilityPage/socialResponsibilityPage.js");
